module.exports = __webpack_public_path__ + "img/think.75e3413f.png";